////////////////////////////////////////////////////
//                                                //
//  PÁGINA HOME MODERNA - CONECTADA AO BACKEND    //
//  Design iPhone-like com Bootstrap 5          //
//  Mobile-first e totalmente responsivo          //
//  Usando as mesmas APIs do sistema original     //
//                                                //
////////////////////////////////////////////////////

import React, { useState, useEffect } from "react";

// Componentes modernos
import ModernHeader from '../components/modern_header';
import ModernFilter from '../components/modern_filter';
import ModernProductCard from '../components/modern_product_card';
import ModernLoader, { ProductSkeleton } from '../components/modern_loader';
import ModernCartSidebar from '../components/modern_cart_sidebar';

// Hooks
import usePageTitle from '../hooks/usePageTitle';

// Serviços
import api from "../services/api";


function ModernHome() {
  usePageTitle('');
  // Estados principais (mesmos da home original)
  const [produtos, setProdutos] = useState([]);
  const [carrinho, setCarrinho] = useState([]);
  const [cartSidebarOpen, setCartSidebarOpen] = useState(false);
  const [grupos, setGrupos] = useState([]);
  const [botao, setBotao] = useState(false);
  
  // Estados de controle
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [initialLoad, setInitialLoad] = useState(true);
  const [hasMoreProducts, setHasMoreProducts] = useState(true);
  
  // Controle de paginação (mesmo esquema original)
  const [queryStart, setQueryStart] = useState(0);
  const [queryEnd, setQueryEnd] = useState(8);

  // Parâmetros da loja
  const [idLoja, setIdLoja] = useState(null);
  const [gruposQuery, setGruposQuery] = useState('{"grupo":"","preco_minimo":"","preco_maximo":"","ordem":"[Grupo_Imaginarium].[dbo].[PRODUTOS].DATA_CADASTRAMENTO"}');
  const [textoFiltro, setTextoFiltro] = useState('');
  const [estoque, setEstoque] = useState(0);

  // Inicialização da página (baseada na home original)
  useEffect(() => {
    const initializePage = async () => {
      try {
        console.log('🚀 Iniciando página...');
        setInitialLoad(true);
        setLoading(true);
        
        // Pegar ID da loja da URL (mesmo da home original)
        const params = new URLSearchParams(window.location.search);
        let id = params.get('id');
        console.log('📍 ID da loja:', id);
        
        // Se não tiver ID na URL, usar um padrão ou buscar de sessionStorage
        if (!id) {
          id = sessionStorage.getItem('loja') || '1'; // ID padrão para desenvolvimento
          console.log('⚠️ ID da loja não encontrado na URL, usando padrão:', id);
          
          // Atualizar a URL com o ID padrão
          const newUrl = `${window.location.pathname}?id=${id}`;
          window.history.replaceState({}, '', newUrl);
        }

        setIdLoja(id);
        sessionStorage.setItem('loja', id);
        console.log('✅ ID da loja configurado:', id);

        // Limpar carrinho se necessário (lógica original)
        if (sessionStorage.getItem('comprar')) {
          const itensCarrinho = sessionStorage.getItem('comprar').split(';');
          if (itensCarrinho.length === 1 && itensCarrinho[0] === '') {
            sessionStorage.removeItem('comprar');
          }
        }

        // Carregar carrinho primeiro (não bloqueia o fluxo se falhar)
        console.log('🛒 Carregando carrinho...');
        try {
          await carrinhoDeCompras();
          console.log('✅ Carrinho carregado');
        } catch (error) {
          console.error('⚠️ Erro ao carregar carrinho, continuando sem ele:', error);
        }

        // Limpar requisições antigas do localStorage (dados obsoletos)
        localStorage.removeItem('failedCartUpdates');

        // Buscar grupos (mesma API original)
        console.log('📂 Buscando grupos de produtos...');
        const gruposResponse = await api.post('buscar_grupo_produtos', {
          id_loja: id,
        }).then((response) => {
          return response;
        });
        console.log('📂 Resposta grupos:', gruposResponse);

        if (gruposResponse.data) {
          const estoqueSeguranca = gruposResponse.data.estoque_seguranca;
          const telefoneLoja = gruposResponse.data.telefone_loja;
          console.log('📦 Estoque segurança:', estoqueSeguranca);
          console.log('📞 Telefone da loja:', telefoneLoja);
          setBotao(true); // Sempre permite checkout
          setGrupos(gruposResponse.data.data);
          setEstoque(estoqueSeguranca);

          // Salvar telefone da loja no sessionStorage para usar no modal WhatsApp
          console.log('🔍 Verificando telefone recebido da API:', {
            telefoneLoja,
            tipo: typeof telefoneLoja,
            isNull: telefoneLoja === null,
            isUndefined: telefoneLoja === undefined,
            isStringNull: telefoneLoja === 'null'
          });

          if (telefoneLoja && telefoneLoja !== null && telefoneLoja !== 'null' && telefoneLoja !== undefined) {
            sessionStorage.setItem('telefone_loja', telefoneLoja);
            console.log('✅ Telefone da loja salvo no sessionStorage:', telefoneLoja);
          } else {
            console.warn('⚠️ Telefone da loja não disponível ou é null:', telefoneLoja);
            // Não salvar nada se não tiver telefone válido
            sessionStorage.removeItem('telefone_loja');
          }

          // Buscar produtos iniciais
          console.log('🛍️ Buscando produtos iniciais...');
          const defaultQuery = JSON.stringify({
            grupo: "",
            preco_minimo: "",
            preco_maximo: "",
            ordem: "[Grupo_Imaginarium].[dbo].[PRODUTOS].DATA_CADASTRAMENTO"
          });
          console.log('🔍 Query padrão:', defaultQuery);

          const newQueryStart = 0;
          const newQueryEnd = 18;
          const produtosNovo = [];

          const lista = await pegaProximosProdutos(id, newQueryStart, newQueryEnd, defaultQuery, '', estoqueSeguranca, produtosNovo);
          console.log('📋 Lista de produtos:', lista);
          
          setQueryStart(lista[0]);
          setQueryEnd(lista[1]);
          setProdutos(lista[2]);
          setGruposQuery(defaultQuery);
          setTextoFiltro('');

          if (lista[0] > lista[1]) {
            setHasMoreProducts(false);
          } else {
            setHasMoreProducts(true);
          }
          
          console.log('✅ Inicialização concluída com sucesso');
        } else {
          console.error('❌ Resposta de grupos inválida');
        }

      } catch (error) {
        console.error('❌ Erro ao inicializar página:', error);
      } finally {
        console.log('🔄 Finalizando loading...');
        setInitialLoad(false);
        setLoading(false);
      }
    };

    initializePage();

    // --- AJUSTE BFCache ---
    const handlePageShow = (event) => {
      if (event.persisted) {
        console.log('🔄 BFCache restore detectado na Home. Re-inicializando...');
        // Re-executa a inicialização para buscar dados frescos (especialmente o carrinho)
        initializePage();
      }
    };
    
    window.addEventListener('pageshow', handlePageShow);
    
    return () => {
      // Limpar o listener ao desmontar
      window.removeEventListener('pageshow', handlePageShow);
    };
    // --- FIM AJUSTE BFCache ---

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Scroll infinito (baseado na lógica original)
  useEffect(() => {
    let feito = 0;

    const handleScroll = async () => {
      if (queryStart > queryEnd) {
        setHasMoreProducts(false);
        return;
      }

      const scrollPosition = parseInt(document.scrollingElement.scrollTop + document.scrollingElement.clientHeight);
      const scrollThreshold = document.scrollingElement.scrollHeight - 600;

      if (scrollPosition > scrollThreshold) {
        if (feito === 0) {
          feito = 1;
          setLoadingMore(true);
          
          try {
            const lista = await pegaProximosProdutos(idLoja, queryStart, queryEnd, gruposQuery, textoFiltro, estoque, produtos);
            setQueryStart(lista[0]);
            setQueryEnd(lista[1]);
            setProdutos(lista[2]);
            feito = 0;
          } catch (error) {
            console.error('Erro ao carregar mais produtos:', error);
            feito = 0;
          } finally {
            setLoadingMore(false);
          }
        }
      } else {
        feito = 0;
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [idLoja, queryStart, queryEnd, gruposQuery, textoFiltro, estoque, produtos]);

  // Função de busca de produtos (simplificada para filtros)
  const searchProdutos = async (gruposquery, texto) => {
    try {
      setLoading(true);

      if (!idLoja) {
        console.error('ID da loja não definido');
        return;
      }

      // Buscar produtos com novos filtros
      const newQueryStart = 0;
      const newQueryEnd = 8;
      const produtosNovo = [];

      const lista = await pegaProximosProdutos(idLoja, newQueryStart, newQueryEnd, gruposquery, texto, estoque, produtosNovo);
      
      setQueryStart(lista[0]);
      setQueryEnd(lista[1]);
      setProdutos(lista[2]);
      setGruposQuery(gruposquery);
      setTextoFiltro(texto);

      if (lista[0] > lista[1]) {
        setHasMoreProducts(false);
      } else {
        setHasMoreProducts(true);
      }
      
    } catch (error) {
      console.error('Erro ao buscar produtos:', error);
    } finally {
      setLoading(false);
    }
  };

  // Função para pegar próximos produtos (baseada na original)
  const pegaProximosProdutos = async (id_loja, query_start, query_end, gruposquery, texto, estoque, produtos_novo) => {
    console.log('🔄 Chamando pegaProximosProdutos com:', {
      id_loja,
      query_start,
      query_end,
      gruposquery,
      texto,
      estoque,
      produtos_novo: produtos_novo.length
    });
    
    try {
      const resp = await api.post('buscar_numero_itens', {
        id_loja: id_loja,
        query_start: query_start,
        query_end: query_end,
        gruposquery: gruposquery,
        texto: texto,
        estoque: estoque,
      }).then((response) => {
        return response;
      });

      console.log('📦 Resposta da API buscar_numero_itens:', resp);
      console.log('📦 Dados retornados:', resp.data);

      if (!resp.data) {
        console.error('❌ Resposta da API sem dados');
        return [query_start, query_end, produtos_novo];
      }

      const newQueryStart = query_start + 8;
      const newQueryEnd = resp.data.query_end;
      const produtosAtualizados = produtos_novo.concat(resp.data.data || []);

      console.log('✅ Produtos processados:', {
        newQueryStart,
        newQueryEnd,
        produtosCount: produtosAtualizados.length,
        novos: (resp.data.data || []).length
      });

      return [newQueryStart, newQueryEnd, produtosAtualizados];
    } catch (error) {
      console.error('❌ Erro na API buscar_numero_itens:', error);
      return [query_start, query_end, produtos_novo];
    }
  };

  // Função de carrinho (convertida para formato moderno)
  const carrinhoDeCompras = async () => {
    try {
      console.log('🔄 INÍCIO carrinhoDeCompras - Estado atual:', carrinho.length, 'itens');
      console.log('🔄 SessionStorage comprar:', sessionStorage.getItem('comprar'));
      console.log('🔄 SessionStorage login:', sessionStorage.getItem('login'));
      
      if (sessionStorage.getItem('login') && !sessionStorage.getItem('login').includes('/')) {
        console.log('👤 Usuário logado, buscando carrinho do servidor...');

        // Usar o login do usuário (email/token) para buscar o carrinho
        const usuario = sessionStorage.getItem('login');

        const resp = await api.post('buscar_interesses', {
          usuario: usuario,   // Email/token do usuário (como sistema antigo)
          loja: sessionStorage.getItem('loja') || idLoja,
        });

        console.log('📡 Resposta do servidor:', resp?.data);

        if (resp && resp.data && resp.data.car) {
          console.log('📦 Carrinho do servidor RAW:', resp.data.car);
          console.log('📊 Total de registros do servidor:', resp.data.car.length);

          // Agrupar itens duplicados por ID (previne duplicatas do banco)
          const itemsAgrupados = {};

          resp.data.car.forEach(item => {
            console.log('🔄 Processando item:', item);

            const itemId = item.id;
            const quantidade = item.quantidade || item[item.id]?.carrinho || 1;

            if (itemsAgrupados[itemId]) {
              // Item duplicado - somar quantidade
              console.log(`⚠️ Duplicata detectada! ID: ${itemId}, somando quantidade ${quantidade}`);
              itemsAgrupados[itemId].quantidade += quantidade;
            } else {
              // Novo item - adicionar ao grupo
              itemsAgrupados[itemId] = {
                id: itemId,
                nome: item.nome || item.descricao || `Produto ${itemId}`,
                preco: item.preco || item[item.id]?.preco || 0,
                quantidade: quantidade,
                img: item.img || item[item.id]?.img || '',
                estoque: item.estoque || item[item.id]?.estoque || 0
              };
              console.log('✅ Novo item adicionado:', itemsAgrupados[itemId]);
            }
          });

          // Converter objeto agrupado em array
          const carrinhoModerno = Object.values(itemsAgrupados);

          console.log('✅ Carrinho após agrupar duplicatas:', carrinhoModerno);
          console.log('📊 Itens únicos no carrinho:', carrinhoModerno.length);
          setCarrinho(carrinhoModerno);

          const sessao = carrinhoModerno.map(item => JSON.stringify(item));
          sessionStorage.setItem('comprar', sessao.join(';'));
          console.log('💾 Salvou no sessionStorage:', sessao.join(';'));
        } else {
          console.log('📝 Carrinho vazio no servidor');
          setCarrinho([]);
        }
      } else {
        console.log('🔒 Usuário não logado, buscando carrinho local...');
        const carrinhoList = [];

        if (sessionStorage.getItem('comprar')) {
          const carrinhoItems = sessionStorage.getItem('comprar').split(';');
          console.log('📋 Itens no sessionStorage:', carrinhoItems.length);
          
          carrinhoItems.forEach(function (element) {
            if (element && element.trim()) {
              try {
                const item = JSON.parse(element);
                console.log('🔍 Processando item:', item);
                
                // Se o item já está no formato moderno, usar diretamente
                if (item.quantidade !== undefined) {
                  carrinhoList.push(item);
                } else {
                  // Converter formato antigo para moderno
                  const itemModerno = {
                    id: item.id,
                    nome: item.nome || `Produto ${item.id}`,
                    preco: item[item.id]?.preco || 0,
                    quantidade: item[item.id]?.carrinho || 1,
                    img: item[item.id]?.img || '',
                    estoque: item[item.id]?.estoque || 0
                  };
                  carrinhoList.push(itemModerno);
                }
              } catch (error) {
                console.warn('⚠️ Erro ao parsear item do carrinho:', element, error);
              }
            }
          });

          console.log('✅ Carrinho local carregado:', carrinhoList);
          setCarrinho(carrinhoList);
        } else {
          console.log('📝 Nenhum item no carrinho local');
          setCarrinho([]);
        }
      }
    } catch (error) {
      console.error('❌ Erro ao carregar carrinho:', error);
      setCarrinho([]);
    }
  };

  // Handlers para os filtros modernos
  const handleFilterChange = (filtrosModernos) => {
    console.log('📁 handleFilterChange called with:', filtrosModernos);
    
    // Converter filtros modernos para o formato original
    let gruposArray = [];
    let preco_minimo = '';
    let preco_maximo = '';
    let ordem = '[Grupo_Imaginarium].[dbo].[PRODUTOS].DATA_CADASTRAMENTO';

    // Processar categorias (pode ser array ou string)
    if (filtrosModernos.Categoria) {
      if (Array.isArray(filtrosModernos.Categoria)) {
        // Se são múltiplas categorias, adicionar todas ao array
        gruposArray = gruposArray.concat(filtrosModernos.Categoria);
        console.log('📂 Multiple categories selected:', filtrosModernos.Categoria);
      } else {
        gruposArray.push(filtrosModernos.Categoria);
      }
    }
    
    // Processar outros grupos de filtros
    Object.keys(filtrosModernos).forEach(key => {
      if (key !== 'Categoria' && key !== 'promocao' && key !== 'estoque_baixo' && key !== 'novidades') {
        const value = filtrosModernos[key];
        if (Array.isArray(value) && value.length > 0) {
          // Para outros grupos, adicionar todos os valores
          gruposArray = gruposArray.concat(value);
          console.log('📂 Adding filters from group', key, ':', value);
        } else if (typeof value === 'string') {
          gruposArray.push(value);
          console.log('📂 Using filter from group', key, ':', value);
        }
      }
    });

    if (filtrosModernos.promocao) {
      console.log('🏷️ Promotion filter activated');
      // Lógica para promoções pode ser implementada aqui
    }

    if (filtrosModernos.estoque_baixo) {
      console.log('⚠️ Low stock filter activated');
      // Lógica para estoque baixo pode ser implementada aqui
    }
    
    if (filtrosModernos.novidades) {
      console.log('⭐ New items filter activated');
      // Lógica para novidades pode ser implementada aqui
    }

    // Converter array de grupos para string separada por vírgula
    const grupoString = gruposArray.length > 0 ? gruposArray.join(',') : '';

    const gruposQuery = JSON.stringify({
      grupo: grupoString,
      preco_minimo: preco_minimo,
      preco_maximo: preco_maximo,
      ordem: ordem
    });

    console.log('🔍 Searching with multiple groups:', gruposArray);
    console.log('🔍 Final query:', gruposQuery);
    searchProdutos(gruposQuery, textoFiltro);
  };

  const handleSearch = (texto) => {
    searchProdutos(gruposQuery, texto);
  };

  const handleAddToCart = async (produto) => {
    try {
      console.log('🛒 Adicionando ao carrinho:', produto);

      // Extrair dados do produto na estrutura correta
      const produtoData = {
        id: produto.id,
        nome: produto.props?.detalhes?.DESC_PRODUTO || `Produto ${produto.id}`,
        preco: produto.props?.preco || 0,
        img: produto.props?.img || '',
        estoque: produto.props?.estoque || 0
      };

      console.log('📦 Dados do produto formatados:', produtoData);

      // Verificar quantidade atual (para enviar ao banco)
      const carrinhoAtualTemp = [...carrinho];
      const produtoExistenteTemp = carrinhoAtualTemp.find(item => item.id === produtoData.id);
      const quantidadeNova = produtoExistenteTemp ? produtoExistenteTemp.quantidade + 1 : 1;

      // ============================================================
      // IMPORTANTE: SE LOGADO, SALVAR NO BANCO PRIMEIRO
      // Só adiciona localmente se o banco confirmar sucesso
      // ============================================================
      if (sessionStorage.getItem('login') && !sessionStorage.getItem('login').includes('/')) {
        // Usar o login do usuário (email/token) diretamente
        const usuario = sessionStorage.getItem('login');

        const dict_itens = {
          usuario: usuario,   // Email/token do usuário (como sistema antigo)
          loja: sessionStorage.getItem('loja') || idLoja,
          comprar: produtoData.id,
          quantidade: quantidadeNova
        };

        console.log('💾 Tentando salvar no banco PRIMEIRO:', dict_itens);

        try {
          // Salvar no servidor (1 tentativa apenas)
          await api.post('add_session_db', { dict_itens });

          console.log('✅ Salvo no banco com sucesso - AGORA pode adicionar ao carrinho local');
        } catch (error) {
          console.error('❌ Erro ao salvar no banco:', error);

          // Analisar tipo de erro
          let errorMessage = 'Erro ao adicionar produto ao carrinho. Tente novamente.';

          if (error.response) {
            console.error('🔴 Erro do servidor:', error.response.status, error.response.data);
            errorMessage = `Erro do servidor (${error.response.status}). Tente novamente.`;
          } else if (error.request) {
            console.error('📡 Servidor não respondeu - pode estar offline');
            errorMessage = 'Servidor offline. Verifique sua conexão.';
          } else {
            console.error('⚠️ Erro desconhecido:', error.message);
          }

          // NÃO ADICIONAR AO CARRINHO LOCAL SE FALHAR NO BANCO
          // Isso evita inconsistência entre carrinho local e banco de dados
          throw new Error(errorMessage);
        }
      }

      // ============================================================
      // SÓ CHEGA AQUI SE:
      // 1. Usuário não está logado (carrinho apenas local), OU
      // 2. Banco confirmou sucesso (carrinho sincronizado)
      // ============================================================

      // Verificar se o produto já está no carrinho
      const carrinhoAtual = [...carrinho];
      const produtoExistente = carrinhoAtual.find(item => item.id === produtoData.id);

      if (produtoExistente) {
        // Se já existe, aumentar a quantidade
        produtoExistente.quantidade += 1;
        console.log('📈 Quantidade aumentada para:', produtoExistente.quantidade);
      } else {
        // Se não existe, adicionar novo item no formato correto
        const novoItem = {
          id: produtoData.id,
          nome: produtoData.nome,
          preco: produtoData.preco,
          quantidade: 1,
          img: produtoData.img,
          estoque: produtoData.estoque
        };
        carrinhoAtual.push(novoItem);
        console.log('➕ Novo item adicionado:', novoItem);
      }

      // Atualizar estado local
      setCarrinho(carrinhoAtual);

      // Salvar no sessionStorage
      const sessao = carrinhoAtual.map(item => JSON.stringify(item));
      sessionStorage.setItem('comprar', sessao.join(';'));

      // Abrir sidebar do carrinho
      setCartSidebarOpen(true);

      console.log('✅ Produto adicionado ao carrinho com sucesso');
      return true; // Retornar sucesso
    } catch (error) {
      console.error('❌ Erro ao adicionar produto ao carrinho:', error);
      throw error; // Propagar erro para o componente mostrar mensagem
    }
  };

  const handleViewDetails = (produto) => {
    // Navegar para página de detalhes (mesma lógica original)
    window.location.href = `/detalhe?id=${produto.id}&loja=${idLoja}`;
  };

  // Converter grupos para formato moderno
  const gruposModernos = grupos.map(grupo => ({
    nome: 'Categoria',
    valores: grupos
  })).slice(0, 1); // Apenas um grupo de categorias

  // Loading inicial
  if (initialLoad) {
    return (
      <div className="main-container">
        <ModernHeader 
          callback={handleSearch} 
          cartItems={carrinho}
          onCartClick={() => setCartSidebarOpen(true)}
        />
        <div className="container-fluid content-with-bottom-nav">
          <div className="d-flex justify-content-center align-items-center flex-column" style={{ minHeight: '60vh' }}>
            <div className="loading-spinner mb-3 d-block" style={{ width: '60px', height: '60px' }}></div>
            <h5 className="text-muted">Carregando catálogo...</h5>
          
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="main-container">
      {/* Header moderno */}
      <ModernHeader 
        callback={handleSearch} 
        cartItems={carrinho}
        onCartClick={() => setCartSidebarOpen(true)}
      />

      {/* Container principal */}
      <div className="container-fluid content-with-bottom-nav mt-5">
        <div className="row">
          {/* Sidebar de filtros - Desktop */}
          <div className="col-lg-3 d-none d-lg-block">
            <div className="sticky-top">
              <ModernFilter 
                grupos={gruposModernos}
                activeFilters={{}}
                onFilterChange={handleFilterChange}
              />
            </div>
          </div>

          {/* Área principal de produtos */}
          <div className="col-12 col-lg-9">
            {/* Filtros mobile */}
            <div className="d-lg-none mb-3">
              <ModernFilter
                grupos={gruposModernos}
                activeFilters={{}}
                onFilterChange={handleFilterChange}
                isMobile={true}
              />
            </div>

            {/* Header de resultados */}
            <div className="d-flex justify-content-between align-items-center mb-4">
              <div>
                <h4 className="mb-1 fw-bold">Produtos</h4>
                <p className="text-muted mb-0">
                  {produtos.length} produto{produtos.length !== 1 ? 's' : ''} encontrado{produtos.length !== 1 ? 's' : ''}
                </p>
              </div>
            </div>

            {/* Grid de produtos */}
            {loading ? (
              <ProductSkeleton count={6} />
            ) : produtos.length > 0 ? (
              <>
                <div className="products-grid">
                  {produtos.map((produto, index) => (
                    <ModernProductCard
                      key={`${produto.id}-${index}`}
                      produto={produto}
                      onAddToCart={handleAddToCart}
                      onViewDetails={handleViewDetails}
                    />
                  ))}
                </div>

                {/* Loading mais produtos */}
                {loadingMore && (
                  <ModernLoader 
                    message="Carregando mais produtos..." 
                    isVisible={true}
                  />
                )}

                {/* Mensagem fim dos produtos */}
                {!hasMoreProducts && produtos.length > 0 && (
                  <div className="text-center py-5">
                    <i className="bi bi-check-circle fs-1 text-success d-block mb-2"></i>
                    <h5>Todos os produtos foram carregados</h5>
                    <p className="text-muted">
                      {produtos.length} produto{produtos.length !== 1 ? 's' : ''} no total
                    </p>
                  </div>
                )}
              </>
            ) : (
              // Estado vazio com debug
              <div className="text-center py-5">
                <i className="bi bi-search fs-1 text-muted d-block mb-3"></i>
                <h4>Nenhum produto encontrado</h4>
                <p className="text-muted mb-4">
                  Tente ajustar os filtros ou termos de busca
                </p>
                
                <button 
                  className="btn btn-modern"
                  onClick={() => {
                    console.log('🔄 Tentando recarregar produtos...');
                    const defaultQuery = JSON.stringify({
                      grupo: "",
                      preco_minimo: "",
                      preco_maximo: "",
                      ordem: "[Grupo_Imaginarium].[dbo].[PRODUTOS].DATA_CADASTRAMENTO"
                    });
                    searchProdutos(defaultQuery, '');
                  }}
                >
                  <i className="bi bi-arrow-clockwise me-1"></i>
                  Limpar filtros
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Carrinho lateral moderno */}
      <ModernCartSidebar 
        isOpen={cartSidebarOpen}
        onClose={() => setCartSidebarOpen(false)}
        cartItems={carrinho}
        onUpdateCart={(updatedItems) => {
          setCarrinho(updatedItems);
          // Atualizar sessionStorage
          const sessao = updatedItems.map(item => JSON.stringify(item));
          sessionStorage.setItem('comprar', sessao.join(';'));
        }}
      />

      {/* FAB para filtros mobile */}
      {/* <button 
        className="fab d-lg-none"
        onClick={() => {
          const filterElement = document.querySelector('.d-lg-none .modern-card');
          if (filterElement) {
            filterElement.scrollIntoView({ behavior: 'smooth' });
          }
        }}
        aria-label="Ir para filtros"
      >
        <i className="bi bi-funnel"></i>
      </button> */}
    </div>
  );
}

export default ModernHome;